import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const blink = keyframes`
    0%, 50% {
        opacity: 1;
    }
    51%, 100% {
        opacity: 0;
    }
`;

const fadeInUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const TypingTextContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    font-family: 'SCDream4', sans-serif;
    margin: 20px 0;
    animation: ${fadeInUp} 0.6s ease-out;
`;

export const TypingTextWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: ${(props) => props.size || '32px'};
    font-weight: 700;
    color: #333333;
    line-height: 1.2;

    @media (max-width: 768px) {
        font-size: ${(props) => props.mobileSize || '24px'};
    }

    @media (max-width: 480px) {
        font-size: ${(props) => props.smallSize || '20px'};
    }
`;

export const StaticText = styled.span`
    color: ${(props) => props.color || '#333333'};
    transition: color 0.3s ease;
`;

export const TypingText = styled.span`
    color: ${(props) => props.typingColor || '#667eea'};
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    position: relative;
    min-width: ${(props) => props.minWidth || '0'};
    display: inline-block;
`;

export const Cursor = styled.span`
    display: inline-block;
    width: 2px;
    height: ${(props) => props.height || '1.2em'};
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    margin-left: 2px;
    animation: ${blink} 1s infinite;
    vertical-align: middle;
`;

export const TypingTextCard = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    padding: 40px;
    text-align: center;
    max-width: 600px;
    margin: 0 auto;
    animation: ${fadeInUp} 0.6s ease-out;

    @media (max-width: 768px) {
        padding: 30px 20px;
        margin: 0 20px;
    }
`;

export const TypingTextTitle = styled.h2`
    font-size: 24px;
    font-weight: 600;
    color: #666666;
    margin: 0 0 20px 0;
    font-family: 'SCDream4', sans-serif;
`;

export const TypingTextSubtitle = styled.p`
    font-size: 16px;
    color: #888888;
    margin: 20px 0 0 0;
    font-family: 'SCDream4', sans-serif;
    line-height: 1.5;
`;

export const TypingTextDemo = styled.div`
    padding: 60px 20px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;
